// extracted by mini-css-extract-plugin
export default {"container":"W5VS","header":"gYhN","handle":"P1mI","content":"uQ87","open-button":"adSV","openButton":"adSV"};